import React from 'react';
import {
  Box,
  TextField,
  Button,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

export const EmployeeListBox = ({ handleAdd, formik }) => {
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box>
            <FormControlLabel
              id="searchYn"
              name="searchYn"
              label="미사용"
              control={
                <Checkbox
                  checked={formik.values.searchYn}
                  onChange={formik.handleChange}
                />
              }
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': { m: 1, width: '25ch' },
            }}
          >
            <TextField
              variant="standard"
              required
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색 키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
              error={
                formik.touched.searchKeyword &&
                Boolean(formik.errors.searchKeyword)
              }
              helperText={
                formik.touched.searchKeyword && formik.errors.searchKeyword
              }
            >
              {/* <MenuItem value="">검색키워드</MenuItem> */}
              <MenuItem value="usrNm">이름</MenuItem>
              <MenuItem value="usrNo">사번</MenuItem>
              <MenuItem value="dptNm">부서</MenuItem>
              <MenuItem value="gradeNm">직급</MenuItem>
              <MenuItem value="telNo">연락처</MenuItem>
              <MenuItem value="emlAddr">이메일</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              required
              id="searchWords"
              name="searchWords"
              label="검색어"
              onChange={formik.handleChange}
              error={
                formik.touched.searchWords && Boolean(formik.errors.searchWords)
              }
              helperText={
                formik.touched.searchWords && formik.errors.searchWords
              }
            />
          </Box>

          <Box>
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              검색
            </Button>
          </Box>
        </Box>
        <Box textAlign="center">
          <Button color="primary" variant="contained" onClick={handleAdd}>
            추가
          </Button>
        </Box>
      </Box>
    </div>
  );
};
